const config = {
  domain:process.env.VUE_APP_Auth_Domain,
  clientId:process.env.VUE_APP_Auth_Client_id
}
export default config;
